import { render, staticRenderFns } from "./employees.vue?vue&type=template&id=12208302&scoped=true"
import script from "./employees.vue?vue&type=script&lang=js"
export * from "./employees.vue?vue&type=script&lang=js"
import style0 from "./employees.vue?vue&type=style&index=0&id=12208302&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12208302",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12208302')) {
      api.createRecord('12208302', component.options)
    } else {
      api.reload('12208302', component.options)
    }
    module.hot.accept("./employees.vue?vue&type=template&id=12208302&scoped=true", function () {
      api.rerender('12208302', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/archives/components/employees.vue"
export default component.exports